import {Http, Util} from '@/utils';
import {Environment} from '@/environments/environment';

// mock 部分
// export function getCodePictrue(){
//     // const fd = new FileReader();
//     const picFile = `data:image/jpeg;base64,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`;
//     return new Promise((res,rej) => {
//             res(picFile);
//     })
// }

// 验证图片验证码
// export function verifyPicCode(code:string):Promise<any>{
//     const res = code === "8360" ? true : false;
//     return Promise.resolve(res);
// }

// 验证码登录(未使用)
// export function verifyCodeLogin(self:any,phone:string,code:string){
//     const pm = Object.create(null);
//     pm.phone = phone;
//     pm.code = code;
//     pm.success = true;
//     const promis = self.$http.post('/runtimeapi/app/loginByPhone', pm, true);
//     promis.then((res:any) => {
//         if(!res.success || res.status === 400){
//             res.message && self.$message({
//                 message: res.message,
//                 type: "error"
//             });
//         }
//     });
// }

// 发送短信验证码
export function sendVerifyCode(self: any, phone: string, codeKey: any, code: any): Promise<boolean> {
    console.log(codeKey);
    console.log(code);
    //@ts-ignore
    const promis = self.$http.postwithheader('/runtimeapi/sms/sendValidate', `phone=${phone}`, null, {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Captcha-Key': codeKey,
        'Captcha-Code': code
    }, true);
    return new Promise((res) => {
        // @ts-ignore
        promis.then(result => {
            if (result && result.data && result.data.success) {
                self.$Message.success("已发送")
            } else {
                self.$Message.error("发送失败：" + result.data.message);
            }
        }).catch((err: any) => {
            self.$Message.error("发送失败：" + err.data.message)
        })
    })
}

// 校验短信验证码(未使用)
// export function checkVerifyCode(self :any,phone:string,code:string):Promise<any>{
//     const pm = Object.create(null);
//     pm.phone = phone;
//     pm.code = code;
//     const promis = self.$http.post('/runtimeapi/sms/sendValidate', pm, true);
//     // public post(url: string, params: any = {}, isloading?: boolean, serialnumber?: number): Promise<any> {
//     promis.then(res => {
//         console.log("!!! result is :",res);
//     })
//     return Promise.resolve(true);
// }
export async function getBasicDataRouter() {
    // const prefix:any = 'cssbasicdata'
    const prefix: any = (Environment as any).BasicDataUrl.replace(/\/#\/*/, '')
    return await Http.getInstance().get(`${prefix}/assets/json/router.ts`)
}
export async function getReportsRouter() {
    // const prefix:any = 'cssreports'
    const prefix: any = (Environment as any).ReportUrl.replace(/\/#\/*/, '')
    return await Http.getInstance().get(`${prefix}/assets/json/router.ts`)
}

// TODO:
export async function getRuntimeRouter() {
    const prefix: any = (Environment as any).RuntimeUrl.replace(/\/#\/*/, '')
    return await Http.getInstance().get(`${prefix}/assets/json/router.ts`)
}

export async function getSparepartsRouter() {
    const prefix: any = (Environment as any).SparePartsUrl.replace(/\/#\/*/, '')
    return await Http.getInstance().get(`${prefix}/assets/json/router.ts`)
}

export async function getWorkOrderRouter() {
    const prefix: any = (Environment as any).WkdUrl.replace(/\/#\/*/, '')
    return await Http.getInstance().get(`${prefix}/assets/json/router.ts`)
}
